import * as React from "react";
import { MenuBoxItem } from "./menu-box-item";
import { Element } from "react-scroll";
import { IProductCategoryModel } from "states/menu/menu.models";
import { useAppDispatch } from "app.hook";
import { showMenuDescriptionModal } from "states/global-value/global-value.slice";

export interface IMenuBoxGroupItemProps {
  model: IProductCategoryModel;
}

export function MenuBoxGroupItem({ model }: IMenuBoxGroupItemProps) {
  return model ? (
    <Element name={`cate-${model.id}`} className="element pt-4">
      <div className="menu-group" id={`category-${model.id}`}>
        <div className="menu-title-group flex justify-between pb-4 relative ">
          <h2 className="font-bold text-lg relative z-10 uppercase">{model.name}</h2>
        </div>
        <div className="content-cate advisory-notice pb-4">
          <div dangerouslySetInnerHTML={{ __html: model.description }}></div>
        </div>
        <div className="menu-item-list grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6">
          {model.products.map((product) => (
            <MenuBoxItem
              key={product.id}
              product={product}
              modifierGroups={model.modifierGroups}
            />
          ))}
        </div>
      </div>
    </Element>
  ) : (
    <></>
  );
}
